import BaseApi from './BaseApi'

class CompanyApi extends BaseApi {
  createCompany (companyObj) {
    return this.post('company', companyObj)
  }

  createCompanyEmployee (employeeObj) {
    return this.post(`company/createEmployeeWithSchema`, employeeObj)
  }

  createSalaryGroup (salaryGroupObj) {
    return this.post(`company/salaryGroups`, salaryGroupObj)
  }

  getCompany () {
    return this.get('company')
  }

  getAllSalaryGroups () {
    return this.get('company/salaryGroups/all')
  }

  getEmployee (id) {
    return this.get(`company/employees/${id}`)
  }

  getEmployeeInactivityPeriod (employeeId) {
    return this.get(`company/employees/${employeeId}/periods`)
  }

  editCompany (companyObj) {
    return this.put('company', companyObj)
  }

  editEmployee (employeeObj) {
    return this.put(`company/employees/${employeeObj.id}`, employeeObj)
  }

  editSalaryGroup (salaryGroupObj) {
    return this.put(`company/salaryGroups/${salaryGroupObj.id}`, salaryGroupObj)
  }

  setEmployeeInactivityPeriod (id, inactivityObj) {
    return this.post(`company/employees/${id}/periods`, inactivityObj)
  }

  assignEmployee (id) {
    return this.post(`company/assign/${id}`)
  }

  userifyEmployee (id, email) {
    return this.post(`company/employees/${id}/account`, { email })
  }

  deleteEmployeeAccount (id) {
    return this.delete(`company/employees/${id}/account`)
  }

  downgradeEmployee (id) {
    return this.post(`company/downgrade/${id}`)
  }

  assignSalaryGroupToEmployee (employeeId, salaryGroupId) {
    return this.post('company/assignEmployeeToSalaryGroup', { employee_id: employeeId, salary_group_id: salaryGroupId })
  }

  deleteEmployeeInactivityPeriod (employeeId, periodId) {
    return this.delete(`company/employees/${employeeId}/periods/${periodId}`)
  }

  deleteSalaryGroup (id) {
    return this.delete(`company/salaryGroups/${id}`)
  }

  deleteEmployee (employeeId) {
    return this.delete(`company/employees/${employeeId}`)
  }

  closeOpenPeriod (employeeId, periodId, end) {
    return this.post(`company/employees/${employeeId}/periods/${periodId}/close`, { end })
  }

  periodsExcludedMonth (employeeId) {
    return this.get(`company/employees/${employeeId}/periods/excludedMonths`)
  }

  getEmployees (params) {
    let paramStr = ''
    if (params) {
      paramStr = '?' + Object.entries(params)
        .map(([key, value]) => `${key}=${value}`)
        .join('&')
    }
    return this.get(`company/employees${paramStr}`)
  }

  getArchives () {
    return this.get(`archives`)
  }

  getAllQueues () {
    return this.get(`company/queues`)
  }

  getQueue (queueId) {
    return this.get(`company/queues/${queueId}`)
  }

  downloadQueue (queueId, month) {
    const request = {
      url: `company/queues/${queueId}/download`,
      method: 'get'
    }
    return this.downloadAsFile(request, 'application/zip', `${month}.zip`)
  }
}

export default new CompanyApi()
